import { render, staticRenderFns } from "./DetailsStatus.vue?vue&type=template&id=33418fa1&"
import script from "./DetailsStatus.vue?vue&type=script&lang=js&"
export * from "./DetailsStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports